'use strict';

/**
 * @author Maxim Seredkin
 */

import angular from 'angular';

export default ['$scope', '$uibModalInstance', 'type', 'typeFilters', 'def',
                function($scope, $modalInstance, type, typeFilters, def) {
                    $scope.ok = ok;
                    $scope.cancel = cancel;
                    $scope.isSelect = isSelect;

                    init();

                    // region Function

                    function init() {
                        // инициализация модели
                        $scope.type = angular.copy(type);
                        $scope.filters = angular.copy(typeFilters);
                        $scope.def = angular.copy(def);
                    }

                    function ok(type) {
                        $modalInstance.close(type);
                    }

                    function cancel() {
                        $modalInstance.dismiss();
                    }

                    function isSelect() {
                        return $scope.type != null && $scope.type.id != null;
                    }

                    // endregion
                }];
